const PROJECTS_DATA = [
    {
        id: 1, 
        name: "EasyMealPlanner App",
        objective: "Display recipes and enable users to create a custom meal plan",
        solution: "Create a CRUD application to allow meal planning and showcase my skills in React and Java.",
        projectType: "Full-Stack Development Project",
        team: "Solo Project",
        tools: [
            "React",
            "Next.js",
            "TypeScript",
            "Redux",
            "Java",
            "Spring Boot",
            "Spring Data JPA",
            "Spring Security",
            "PostgreSQL",
            "S3",
            "EC2",
            "CloudFront",
            "RDS",
            "Elastic Beanstalk",
            "Route53"],
        video1: {
            "videoTitle": "Project Demo",
            "videoURL": "https://www.youtube.com/embed/9KedpGfz2kg"
        },
        linkToProject: "https://easymealplanners.com",
        linktoRepo: "https://github.com/stevenGarciaDev/easymealplanner-ui"
    },
    {
        id: 2, 
        name: "BugTracker App",
        objective: "Display and keep progress of reported bugs for an application.",
        solution: "Create a CRUD application to report bugs as well as demonstrate my skills in C# and JavaScript.",
        projectType: "Full-Stack Development Project",
        team: "Solo Project",
        tools: ["C#", "ASP.NET Core", "Entity Framework", "PostgreSQL", "React", "Redux"],
        video1: {
            "videoTitle": "Project Demo",
            "videoURL": "https://www.youtube.com/embed/8A2Xrd-B1L0"
        },
        linkToProject: "https://my-bugtracks.herokuapp.com/",
        linktoRepo: "https://github.com/stevenGarciaDev/BugTrackerUI"
    },
    {
        id: 3,
        name: "Subreddit Timer App",
        objective: "Develop a heatmap based on Reddit API to help users decide when to post on a subreddit.",
        solution: "Build a front end React app for displaying heatmap.",
        projectType: "Front-end Development Project",
        team: "Solo Project",
        tools: ["React", "Styled Components", "React Router", "React Testing Library", "Jest"],
        video1: {
            "videoTitle": "Project Demo",
            "videoURL": "https://www.youtube.com/embed/TJbtIqBiDGI"
        },
        linkToProject: "https://subreddit-timer.netlify.app/",
        linktoRepo: "https://github.com/stevenGarciaDev/subreddit-timer"
    },
    {
        id: 4, 
        name: "BucketList",
        objective: "Enable users to create a bucket list and connect with other people who have similar items.",
        solution: "Build a CRUD application for users to create a bucket list and connect using React and Node.js.",
        projectType: "Full-Stack Development Project",
        team: "Senior Project Team of 4",
        tools: ["React", "Redux", "Node.js", "Express.js", "MongoDB", "Heroku"],
        video1: {
            "videoTitle": "Project Demo",
            "videoURL": "https://www.youtube.com/embed/sXEq82xQ5jM"
        },
        linkToProject: "https://bucket-list-items.herokuapp.com/home",
        linktoRepo: "https://github.com/stevenGarciaDev/MyBucketList-UI"
    }
];

export default PROJECTS_DATA;